export default "__VITE_ASSET__Ch6z5HMk__"